import Secureicon from "../../../../assets/icons/Secure-icon.png";

const DeliveryAddress = ({ orderPayload, orderResponse }) => {
    return (
        <div className="section mb-2">
              <div style={{ 
                // border:"1px dotted #e4e1e1",
                padding:"5px 5px", 
                borderRadius:"7px",
                fontSize:"14px",
                boxShadow:"0 0 3px #0000001f",
                background:"#FFF"
            }}>
            <h6 style={{ borderBottom:"1px dotted rgb(206 204 204)", padding:"5px 5px 11px 5px", marginBottom:"12px", fontWeight:"500"}}>  Delivery Address : </h6>

            <p style={{ color: "#625E55", lineHeight:"24px" }}>
                <i className="bi bi-person iconcolor"></i> <span style={{ color:"#000"}}> {orderPayload?.billing_first_name}{" "}
                {orderPayload?.billing_last_name} </span>
                <span className="ml-00034"> 
                {orderPayload?.billing_mobile}
                <br />
                {orderPayload?.billing_address}
                <br />
                 {orderPayload?.billing_address2},
                {orderPayload?.billing_landmark},
                {orderPayload?.billing_pincode},
                {orderPayload?.billing_city},
                {orderPayload?.billing_state}
                </span>
            </p>
            {orderResponse?.data?.business_details && (
             <p style={{ color: "#625E55" }}>
                Company Name :
                {orderResponse?.data?.business_details?.company_name}
                <br />
                GSTIN :
                {orderResponse?.data?.business_details?.gst_number}
                </p>
            )}
             </div>

             <div className="Secure-payment">
                <div className="d-flex" style={{ gap:"10px"}}> 
                <span> <i className="bi bi-shield-check"></i> </span>
                <span>
                     <h5> Safe & Secure Shopping </h5>
                     <p> Your personal details and interactions are 100% secure with us </p> 
                </span>
                </div>
                <span>
                  <img src={Secureicon} alt="Secure icon" width={70} />
                </span>
            </div>
      </div>
    );
};
export default DeliveryAddress;
